import React from 'react'
import Img from 'gatsby-image'
import styled from '@emotion/styled'
import Slider from 'react-slick'
import { CustomPrevArrow, CustomNextArrow } from './CustomArrows'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// const NotAvailable = styled.span`
//   background: #ff1d01;
//   width: 12px;
//   height: 12px;
//   display: block;
//   float: right;
//   border-radius: 50%;
//   margin-left: 10px;
// `

const InfosContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  h2 {
    &:before {
      content: " - ";
      @media (max-width: ${props => props.theme.breakpoints.s}) {
        display: block;
        content: "";
      }
    }
  }
`;

export default class extends React.Component {

  componentDidMount() {
    window.addEventListener('keydown', this.keyPressHandler);
  }
  
  componentWillUnmount() {
    window.removeEventListener('keydown', this.keyPressHandler);
  }

  keyPressHandler = (e) => {
    if (e.keyCode === 39) {
      this.next();
    } else if(e.keyCode === 37) {
      this.previous();
    }
  }

  next = () => {
    this.slider.slickNext();
  }

  previous = () => {
    this.slider.slickPrev();
  }

  render() {
    const settings = {
      prevArrow: <CustomPrevArrow />,
      nextArrow: <CustomNextArrow />,
      adaptiveHeight: true,
      focusOnSelect: true,
      accessibility: true,
      infinite: true,
      speed: 200,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: this.props.currentSlide || 0,
      dots: false,
      fade: false
    };
    
    return (
      <Slider ref={c => (this.slider = c)} {...settings}>
        { this.props.images && this.props.images.map((image, index) => {
          return (
            <div key={`image-${index}`}>
              {
                image.photo ? (
                  <Img 
                    key={index} alt={image.legend.text} 
                    fixed={image.photo.localFile.childImageSharp.fixed} 
                    placeholderStyle={{
                      filter: "grayscale(100%) contrast(100%)",
                      imageRendering: "pixelated",
                      opacity: 0
                    }}
                  />
                ) : (
                  <React.Fragment>
                    <Img 
                      key={index} alt={image.node.data.title.text} 
                      fixed={image.node.data.item.localFile.childImageSharp.fixed} 
                      placeholderStyle={{
                        filter: "grayscale(100%) contrast(100%)",
                        imageRendering: "pixelated",
                        opacity: 0
                      }}
                    />
                    <div style={{margin: '0 auto'}}>
                      <InfosContainer>
                        <div>
                          <h1>{image.node.data.title.text}</h1>&nbsp;
                          {
                            image.node.data.type && (
                              <h2>{image.node.data.type}</h2>
                            )
                          }
                        </div>
                        {/* {JSON.parse(image.node.data.available) === false && <NotAvailable />} */}
                      </InfosContainer>
                    </div>
                  </React.Fragment>
                )
              }
            </div>
          )}
        )}
      </Slider>
    )
  }
}